'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cleanPath = cleanPath;
exports.removeTrailingSlashes = removeTrailingSlashes;
exports.unpackJobsUrl = unpackJobsUrl;
exports.packJobsUrl = packJobsUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lowercaseKeys = require('lowercase-keys');

var _lowercaseKeys2 = _interopRequireDefault(_lowercaseKeys);

var _lodashOmitby = require('lodash.omitby');

var _lodashOmitby2 = _interopRequireDefault(_lodashOmitby);

var _cleanUrls = require('./clean-urls');

var _cleanUrls2 = _interopRequireDefault(_cleanUrls);

var _extractParams = require('extract-params');

var _interpolateParams = require('interpolate-params');

var _hierarchySlugs = require('./hierarchy/slugs');

var _isSearchResultsPath = require('./is-search-results-path');

var _isSearchResultsPath2 = _interopRequireDefault(_isSearchResultsPath);

var _expandQuery = require('./expand-query');

var _expandQuery2 = _interopRequireDefault(_expandQuery);

function cleanPath(path) {
  if (!path || path === '') {
    return '/';
  } else {
    return removeTrailingSlashes(path);
  }
}

/*
   This function:
     - Removes empty keys
     - Lowercases keys
     - Removes page = 1
     - Trims leading and trailing whitespaces
*/
function cleanQuery(locale, query) {
  var result = {};

  query = (0, _lowercaseKeys2['default'])(query);

  var hasWhereValue = query.hasOwnProperty('where');

  for (var key in query) {
    var value = String(query[key]);

    if (value.trim() === '') {
      continue;
    }

    if (key === 'page' && value === '1') {
      continue;
    }

    if ((key === 'nation' || key === 'location' || key === 'area') && hasWhereValue) {
      continue;
    }

    result[key] = value;
  }

  return result;
}

function transform(params) {
  var allValid = Object.keys(params).every(function (param) {
    return (0, _hierarchySlugs.getIdBySlug)(param, params[param]) !== null;
  });

  return allValid ? params : null;
}

var extractParamsPatterns = _cleanUrls2['default'].map(function (cleanUrl) {
  return {
    pattern: cleanUrl,
    caseSensitive: false,
    transform: transform
  };
});

var interpolateParamsPatterns = _cleanUrls2['default'].map(function (cleanUrl) {
  return {
    pattern: cleanUrl,
    map: _hierarchySlugs.getSlugById
  };
});

var omitBlankValues = function omitBlankValues(query) {
  return (0, _lodashOmitby2['default'])(query, function (value) {
    return value === '';
  });
};

// Remove trailing slash for paths other than '/'

function removeTrailingSlashes(path) {
  return path.replace(/(.)\/$/, '$1');
}

/*
 * Break a jobs url path and query into a single merged object with slugs as ids.
 */

function unpackJobsUrl(locale, path, query) {
  var extractedParams = (0, _extractParams.extractParamsInFirstMatch)(path, extractParamsPatterns);
  var params = extractedParams == null ? {} : (0, _hierarchySlugs.convertSlugsToIds)(extractedParams.params);

  return _extends({}, query, params);
}

/**
 * Make a jobs url out of the results of unpackJobsUrl(...)
 */

function packJobsUrl(params) {
  var mergedQuery = omitBlankValues(params);
  var expandedQuery = (0, _expandQuery2['default'])(mergedQuery);
  var result = (0, _interpolateParams.interpolateParamsInFirstMatch)(interpolateParamsPatterns, expandedQuery);

  // `result` cannot be null here
  // because we have patterns without params at the end of `cleanUrls`

  return {
    path: result.interpolatedPattern,
    query: result.remainingParams
  };
}

exports['default'] = function (locale, path, query) {
  locale = locale.toLowerCase();
  path = cleanPath(path);
  query = cleanQuery(locale, query);

  if ((0, _isSearchResultsPath2['default'])(path)) {
    return packJobsUrl(unpackJobsUrl(locale, path, query));
  } else {
    return { path: path, query: query };
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/qualify-url.js
 ** module id = 544
 ** module chunks = 0
 **/